<h2 mat-dialog-title class="dialog_title">
    <span>
        {{ "Add New Location" | translate }}
    </span>
</h2>
<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper" style="padding: 20px 0;">
        <form [formGroup]="form">
            <mat-form-field appearance="standard" class="full_width_form">
                <ng-container *ngIf="(form.get('location')?.invalid && submited) || showDigitsError">
                    <div class="req_field"></div>
                    <div class="req_label">
                        <div class="angle"></div>
                        <span>
                            {{ showDigitsError ? ('Value must contain only digits' | translate) : ('You need to write here' | translate) }}
                        </span>
                    </div>
                </ng-container>
                <mat-label>{{ 'Location Code' | translate }}</mat-label>
                <input cdkFocusInitial formControlName="location" matInput type="text" 
                       placeholder="{{ 'Location Code' | translate }}"
                       (input)="checkDigits()">
            </mat-form-field>
        </form>
        <div class="instructions">
            <ol>
                <li>
                    {{"Open"}} <b><a target="_blank" style="color: rgb(44, 94, 160) !important;" href="https://www.facebook.com/places/">{{"link" | translate}}</a></b> {{'and find your location' | translate}}
                </li>
                <li>
                    <div>
                        {{"Copy id form the URL of location page" | translate}}
                    </div>

                    <div>
                        <img src="{{ data?.imgRoute }}assets/img/loc_instruction.png" alt="">
                    </div>
                </li>
            </ol>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()">
        {{ "Cancel" | translate }}
    </button>
    <button class="ml-1 d-f-btn" (click)="submitForm()" mat-raised-button cdkFocusInitial color="primary">
        {{ "Add" | translate }}
    </button>
</mat-dialog-actions>